import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { ParticipantViewModel } from "../models/participant-view-model";
import { CreateResult } from "../models/create-result";
import { TMSinkNodesViewModel } from '../models/sink-nodes-view-model';
import { SinkNodeMappingConfigViewModel } from "../models/sinknode-mapping-config-view-model";
import { SinkNodeMappedFieldsViewModel } from '../models/sinknode-mapped-fields-view-model';
import { ParticipantMappingViewModel } from '../models/participant-mapping-view-model';
import { CustomTagParticipantLinkViewModel } from '../models/card-set-participant-link';
import { ProductProfileViewModel } from "../models/product-profile-view-model";
import { CapabilityProfileViewModel } from "../models/capability-profile-view-model";

@Injectable({
  providedIn: 'root'
})
export class ProductProfileService {

  constructor(private _httpService: HttpService) {
  }

  public async GetProductProfiles(): Promise<ProductProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<ProductProfileViewModel[]>(`productProfile/ProductProfiles`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetProductProfilesForParticipant(id: number): Promise<ProductProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<ProductProfileViewModel[]>(`productProfile/GetProductProfiles/${id}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetProductProfilesForParticipantOrAll(): Promise<ProductProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<ProductProfileViewModel[]>(`productProfile/ProductProfilesForParticipantOrAll`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetProductProfilesByParticipantOrAll(participantId: number): Promise<ProductProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<ProductProfileViewModel[]>(`productProfile/ProductProfilesByParticipant/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async UpdateParticipantProductProfiles(productProfiles: ProductProfileViewModel[]): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPut<CreateResult>(`productProfile/UpdateProductProfiles`, productProfiles);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetTerminalsByProductProfile(productProfile: string) {

    const httpResult = await this._httpService.apiGet<number>(`productProfile/GetTerminalsByProductProfile/${productProfile}`);
    return httpResult.body;
  }

  public async DeleteParticipantProductProfilesByParticipantId(id: number): Promise<CreateResult> {
    const httpResult = await this._httpService.apiGet<CreateResult>(`productProfile/DeleteProductProfiles/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }
}
